export default "__VITE_ASSET__4b1ad6a6__"